// src/services/socket.js
import { io } from 'socket.io-client';

const URL = 'https://trivia-server-wvs0.onrender.com';
const baseSocket = io(URL, {
  transports: ['websocket', 'polling'],  // Ensures compatibility
  withCredentials: true
});

export default baseSocket;